import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-table",
  "use": "icon-table-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-table\"><path d=\"M794.720526 125.897911V859.250686L536.873558 687.238779l-24.873558-16.592913-24.873558 16.592913L229.279474 859.250686V125.897911h565.441052m44.821058-44.821058H184.458416V943.030182l327.541584-218.505391L839.541584 943.030182V81.076853z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol